import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, catchError, map, throwError } from 'rxjs';
import { AuthserviceService } from './authservice.service';
import { ApiEndPoints } from '../constants/web-constants';
import { WebServiceMethod } from './web/web-method';
import { WebServiceModel } from './web/web-service-model';
import { ControllerStatus } from '../models/common/controller-status.models';
import { AdminData } from '../models/common/admin_data';
import { DeviceStatusAll } from '../models/common/device-status-all.model';
import { Controller, Device, DeviceActionHistoryModel, DeviceOperationFilters, DeviceStatus } from '../models/common/device.model';
import { ControllerInfo, RebootResponse } from '../models/common/controller-info.model';
import { AlarmStructure, DeviceDetais, DeviceHistoryRecord, TelemetryDetails } from '../models/common/device-telemetry-model';

@Injectable({
  providedIn: 'root',
})
export class ControllerService {
  encrypt_detials: any;
  controller_info: any;
  export_info: any;
  user_specific_info: any;
  cloud_base_url: string = environment.cloud_base_url;
  controller_delete_info: any;
  controller_patch_info: any;
  controller_status_info: any;
  telemetry: any;
  qr_code_content: any;
  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private auth: AuthserviceService
  ) {}
  public get_all_controller() {
        this.httpClient
      .post<any>(this.cloud_base_url + '/cm_service/controller/inventory', {})
      .subscribe((response) => {
        this.controller_info = response;
      });
    return this.controller_info;
  }
  public add_controller(controller_details: any): Observable<any> {
    return this.httpClient
      .put<any>(
        this.cloud_base_url + '/cm_service/controller/inventory',
        controller_details
      )
      .pipe(
        map((response) => {
          this.controller_info = response;
          return this.controller_info;
        }),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 200) {
            this.router.navigate(['admin/add']);
          }
          return throwError('An error occurred while adding the controller.');
        })
      );
  }

  public async controllerPatch(
    controller_status:ControllerStatus
  ): Promise<any> {
    return await this.auth.webService?.list(
      new WebServiceModel(ApiEndPoints.CONTROLLER_UPDATE_URL, WebServiceMethod.Patch, controller_status)
    );
  }


  public async customerAdminAccess(
    controller_status:AdminData
  ): Promise<any> {
    return this.auth.webService?.list(
      new WebServiceModel(ApiEndPoints.INSTALLER_VIEW_ACCESS, WebServiceMethod.Post, controller_status)
    );
  }





  public delete_controller(controller_details: any): Observable<any> {
    return this.httpClient
      .delete<any>(this.cloud_base_url + '/cm_service/controller/inventory', {
        body: controller_details,
      })
      .pipe(
        map((response) => {
          this.controller_delete_info = response;
          return this.controller_delete_info;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError('An error occurred while adding the controller.');
        })
      );
  }

  public patch_controller(controller_details: any): Observable<any> {
    return this.httpClient
      .patch<any>(
        this.cloud_base_url + '/cm_service/controller/inventory',
        controller_details
      )
      .pipe(
        map((response) => {
          this.controller_patch_info = response;
          return this.controller_delete_info;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError('An error occurred while adding the controller.');
        })
      );
  }

  public async DataExport(
    user_details: any,
    token: any
  ): Promise<Observable<boolean>> {
    this.encrypt_detials = await this.auth.encrypt(user_details);
    return this.httpClient
      .post<any>(this.cloud_base_url + '/cm_service/data/export', {
        data: this.encrypt_detials,
        captcha_token: token,
      })
      .pipe(
        map((response) => {
          this.export_info = response;
          return true;
        }),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 200) {
            this.router.navigate(['admin/add']);
          }
          return throwError('An error occurred while data export request.');
        })
      );
  }
  public async getInstallerUserInfo() {
    const response = await this.auth.webService?.list(
      new WebServiceModel(ApiEndPoints.DASHBOARD, WebServiceMethod.Post, {})
    );
      return response?.data ?? [];
  }

  public async get_controller_status(installerUserId?:string) {
    const response = await this.auth.webService?.list(
      new WebServiceModel(ApiEndPoints.STATUS, WebServiceMethod.Post,{"user_id":installerUserId})
    );
    return response?.data ?? [];
  }

  public async get_controller_telemetry() {
    const response = await this.auth.webService?.list(
      new WebServiceModel(ApiEndPoints.TELEMETRY, WebServiceMethod.Get)
    );
    return response?.data ?? [];
  }

  public async get_controller_qr_content() {
    const response = await this.auth.webService?.list(
      new WebServiceModel(ApiEndPoints.QR, WebServiceMethod.Get)
    );
    return response?.data ?? [];
  }



  public async get_controller_list() {
    const response = await this.auth.webService?.list<Controller>(
      new WebServiceModel(ApiEndPoints.CONTROLLER_LIST_URL, WebServiceMethod.Get)
    );
    return response?.data ?? [];
  }




  public async get_device_list() {
    const response = await this.auth.webService?.list<Device>(
      new WebServiceModel(ApiEndPoints.DEVICE_LIST_URL, WebServiceMethod.Get)
    );
    return response?.data ?? [];
  }


  public async get_device_status(controller_uuid:DeviceStatusAll) {
    const response = await this.auth.webService?.list<DeviceStatus>(
      new WebServiceModel(ApiEndPoints.DEVICE_STATUS_URL, WebServiceMethod.Post,{"controller_uuid":controller_uuid})
    );
    return response?.data ?? [];
  }



  public async getControllerInfo(controller_uuid:string) {
    const response = await this.auth.webService?.list<ControllerInfo>(
      new WebServiceModel(ApiEndPoints.CONTROLLER_INFO, WebServiceMethod.Post,{"controller_uuid":controller_uuid})
    );
    return response?.data  ?? [];
  }

  public async rebootControllerApi(controller_uuid:string) {
    const response = await this.auth.webService?.single<RebootResponse>(
      new WebServiceModel(ApiEndPoints.REBOOT_API, WebServiceMethod.Post,{"controller_uuid":controller_uuid})
    );
    return response?.data?.message?? response?.message
  }
  public async get_device_history(controller_uuid:string,device_id:string,field:string, start?:string, stop?:string, aggregate_filter?:string
  ) {
      const response = await this.auth.webService?.list<DeviceHistoryRecord>(
        new WebServiceModel(ApiEndPoints.DEVICE_HISTORY_URL, WebServiceMethod.Post,{"controller_uuid":controller_uuid,"measurement":device_id,"field":field,
          "start":start, "stop":stop, "aggregate_filter":aggregate_filter
        })
      );
      return response?.data ?? [];
    }

    public async telemeteryGet(controller_uuid:string,device_id:string,field_list:string[]) {
      const response = await this.auth.webService?.single<TelemetryDetails>(
        new WebServiceModel(ApiEndPoints.DEVICE_TELEMETERY_URL, WebServiceMethod.Post,{"controller_uuid":controller_uuid,
      "measurement":device_id,
      "field_list":field_list})
      );
      return response?.data ?? {result : []};
    }
    public async alarmHistory(controller_uuid:string,device_id:string) {
      const response = await this.auth.webService?.list<AlarmStructure>(
        new WebServiceModel(ApiEndPoints.ALARM_HISTORY, WebServiceMethod.Post,{"controller_uuid":controller_uuid,
      "device_id":device_id,})
      );
      return response?.data ?? [];
    }
  
  public async get_device_action_filters(controller_uuid:string,device_id:string
  ) {
      const response = await this.auth.webService?.single<DeviceOperationFilters>(
        new WebServiceModel(ApiEndPoints.DEVICE_ACTION_FILTER_URL, WebServiceMethod.Post,{"controller_uuid":controller_uuid,"device_id":device_id
        })
      );
      return response?.data ?? {unique_filters : []};
    }

  public async get_device_action_history(controller_uuid:string,device_id:string, operation_list:string[], offset?:number
  ) {
      const response = await this.auth.webService?.list<DeviceActionHistoryModel>(
        new WebServiceModel(ApiEndPoints.DEVICE_ACTION_HISTORY_URL, WebServiceMethod.Post,{"controller_uuid":controller_uuid,"device_id":device_id,
          "operation_list":operation_list, "offset":offset
        })
      );
      return response?.data ?? [];
    }

    public async getDeviceStatus(controller_uuid:string,device_id:string) {
      const response = await this.auth.webService?.list<DeviceDetais>(
        new WebServiceModel(ApiEndPoints.DEVICE_STATUS, WebServiceMethod.Post,{"controller_uuid":controller_uuid,
      "device_id":device_id,})
      );
      return response?.data ?? [];
    }

    public async getControllerStatus(controller_uuid:string) {
      const response = await this.auth.webService?.single<ControllerStatus>(
        new WebServiceModel(`${ApiEndPoints.CONTROLLER_STATUS}/${controller_uuid}`, WebServiceMethod.Get)
      );
      return response?.data ?? {"controller_status":"offline","controller_uuid":controller_uuid};
    }




  
  }

  




